import React, { useEffect, useState } from 'react'
import EquipmentService from '../../../../../../services/api/equipment.service'
import AddEquipmentType from '../../../equipment-type/add-equipment-type/AddEquipmentType'
import EditEquipmentType from '../../../equipment-type/edit-equipment-type/EditEquipmentType'
import ModalBox from '../../../../../templates/components/ModalBox'
import Table2 from '../../../../../templates/components/Table2'

const EquipmentTypeSettings = (props) => {

    const [isLoader_EquipmentType, setIsLoader_EquipmentType] = useState(false)
    const [equipmentTypeList, setEquipmentTypeList] = useState()
    const [showEquipmentTypeAdd, setShowEquipmentTypeAdd] = useState(false)
    const [masterEquipmentTypeList, setMasterEquipmentTypeList] = useState()
    const [equipmentTypeId, setEquipmentTypeId] = useState()
    const [showEquipmentTypeEdit, setShowEquipmentTypeEdit] = useState(false)
    const [equipmentTypeInitial, setEquipmentTypeInitial] = useState()
    const [selectEquipmentType, setSelectedEquipmentType] = useState()
    const [deleteTypeModal, setDeleteTypeModal] = useState(false)

    const equipmentTypeLookup = () => {
        setIsLoader_EquipmentType(true);
        EquipmentService.equipmentTypeLookup()
            .then((response) => {
                setEquipmentTypeList(response);
                setIsLoader_EquipmentType(false);
            })
            .catch(error => {
                setIsLoader_EquipmentType(false);
            })
    }

    const pullMasterEquipmentType = () => {
        EquipmentService.masterEquipmentTypeLookupForProvider()
            .then(res => {
                setMasterEquipmentTypeList(res)
            })
    }

    const deleteTypeEquipment = (id) => {
        EquipmentService.deleteEquipmentType(id)
            .then(res => {
                equipmentTypeLookup()
            })
    }

    useEffect(() => {
        equipmentTypeLookup()
        pullMasterEquipmentType()
    }, [])

    const equipmentTypeColumns = [
        {
            id: "equipmentType",
            Header: "Name",
            accessor:equipment=>equipment.equipmentType
        },
        {
            id: "masterEquipmentTypeId",
            Header: "Master Equipment Type",
            accessor: (equipmentType) => { if (masterEquipmentTypeList) { return masterEquipmentTypeList.find(obj => obj.masterEquipmentTypeId === equipmentType.masterEquipmentTypeId)?.equipmentType } }
        },
        {
            id: "actionEquipmentType",
            Header: "Action",
            textAlign: 'center',
            disableSortBy: true,
            accessor: (equipmentType, i) => {
                return (
                    <div className='d-flex justify-content-center'>
                        <button className="p-0 ps-1 btn btn-primary" onClick={e => { e.preventDefault(); setEquipmentTypeInitial(equipmentType); return setShowEquipmentTypeEdit(true) }}><i className="icon pencil" /></button>
                        <button className="p-0 ps-1 btn btn-primary ms-1" onClick={e => { e.preventDefault(); setSelectedEquipmentType(equipmentType); return setDeleteTypeModal(true) }}><i className="icon trash" /></button>
                    </div>)
            }
        }
    ]

    return (
        <div>
            <div title="Equipment Type" className='py-3'>
                <Table2 export searchable data={equipmentTypeList} columns={equipmentTypeColumns} loading={isLoader_EquipmentType}
                    extraButtons={[
                        {
                            className: 'btn btn-primary',
                            title: "Add Equipment Type",
                            children:
                                <span><i className='icon plus' /></span>
                            ,
                            onClick: () => {
                                setShowEquipmentTypeAdd(true)
                            }
                        }

                    ]}/>
            </div>

            <ModalBox open={showEquipmentTypeAdd} onClose={() => { setShowEquipmentTypeAdd(false) }} title="Add Equipment Type">
                <AddEquipmentType onClose={() => { equipmentTypeLookup(); return setShowEquipmentTypeAdd(false) }} />
            </ModalBox>
            <ModalBox open={showEquipmentTypeEdit} onClose={() => { setShowEquipmentTypeEdit(false) }} title="Edit Equipment Type">
                <EditEquipmentType initialData={equipmentTypeInitial} onClose={() => { equipmentTypeLookup(); return setShowEquipmentTypeEdit(false) }} />
            </ModalBox>
            <ModalBox open={deleteTypeModal} onClose={() => { setDeleteTypeModal(false) }} title="Delete Equipment Type">
                {selectEquipmentType?.equipmentTypeId && <div className='row d-flex align-items-center justify-content-between'>
                    <div className='col'>
                        Are you sure you want to delete  ?
                    </div>
                    <div className='col-auto'>
                        <button className='btn btn-secondary' onClick={e => { e.preventDefault(); setEquipmentTypeId(selectEquipmentType.equipmentTypeId); return setDeleteTypeModal(false) }}>No</button>
                        <button className='btn btn-primary ms-3' onClick={e => { e.preventDefault(); deleteTypeEquipment(selectEquipmentType.equipmentTypeId); return setDeleteTypeModal(false) }}>Yes</button>
                    </div>
                </div>}
            </ModalBox>
        </div>
    )
}

export default EquipmentTypeSettings